<template>
    <div style="position: relative">
        <h2 class="text-color page-title">شماره Vin خودرو</h2>
        <div class="vin-container">
            <div class="vin-input">
                <input type="text" maxlength="40" placeholder="شماره Vin" class="input" v-model="vin" />
            </div>
            <div>
                <input type="button" value="ارسال" @click="saveVin()" />
            </div>
        </div>
        <div class="error-message" v-if="errorMessage">
            {{errorMessage}}
        </div>
        <div class="help">
            <img class="img-plate" alt="Vin خودرو جدید" title="Vin خودرو جدید" src="../../assets/img/help_vin.jpg" />
        </div>

        <div class="loader" v-if="loader">
            <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "../../service";

export default {
    name: 'vin',
    props: {
        carId: {
            type: Number,
            required: true
        },
        redirect: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            errorMessage: null,
            loader: false,
            vin: null
        };
    },
    methods: {
        saveVin: function () {
            if (!this.vin) {
                this.errorMessage = "وارد کردن Vin خودرو اجباری است.";
                return;
            }

            this.errorMessage = null;
            const entity = {
                CarId: this.carId,
                Vin: this.vin,
            };

            this.loading = true;
            api.saveVin(entity).then((response) => {
                if (response.data && response.data.Status === 200) {
                    this.$router.replace(`/inquiry/${this.redirect}/${this.carId}`);
                } else {
                    if (response.data && response.data.Messages && response.data.Messages.length > 0) {
                        this.errorMessage = response.data.Messages[0];
                    }
                }
            }).catch(() => {
                this.errorMessage = "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
            }).finally(() => {
                this.loading = false;
            });
        },
    }
}
</script>

<style scoped>
.page-title {
    text-align: center;
    padding: 15px;
    border-bottom: solid 1px #09389f;
    margin: 0 20px 10px 20px;
}

.vin-container {
    display: flex;
    align-items: center;
    padding: 0 20px;
}

.vin-input {
    flex: 1;
}

.vin-container input[type=button] {
    border: solid 1px #09389f;
    background-color: #09389f;
    padding: 8px 20px;
    color: white;
    border-radius: 5px;
    margin: 10px 8px 10px 0;
}

.help {
    text-align: center;
}

img.img-plate {
    max-width: 100%;
    padding: 5px 20px;
}

.error-message {
    margin: 0 20px 10px 20px;
}

.loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(64, 64, 64, 0.5);
}
</style>